module.exports = __webpack_public_path__ + "img/img7.213a716e.png";